export interface IProductsStrings {
    products: {
        agreeTermsCheckbox: {
            agree: string;
            terms: string;
            feedback: string;
        }
        buttonText: string;
        moreInformations: string;
        engagementDisclaimer: {
            title: string;
            disclaimer: string[];
        }
        engagementFails: {
            login: string;
            choseOption: string;
        };
        engagementListPage: {
            title: string;
            modal: {
                continueButton: string;
                options: {
                    seeUserDataLabel: string;
                    itemSold: {
                        label: string;
                        howManyItensText: string;
                    }
                    noAgreement: string;
                }
                title: string;
            }
        }
        engagementTable: {
            interestedName: string;
            carPartName: string;
            date: string;
            status: string;
            currentStatus: {
                CLOSED: string;
                CONTACTED: string;
                OPENED: string;
                VIEWED: string;
                SOLD: string;
            }
        }
        informationTitle: string;
        shippingDescription: string;
        shippingDetails: (advertiserName: string) => string;
        type: {
            new: string;
            used: string;
        };
    }
};

export const ProductsStrings: {
    PTBR: IProductsStrings
} = {
    PTBR: {
        products: {
            agreeTermsCheckbox: {
                agree: 'Concordo e aceito os ',
                terms: 'Termos de Uso e Política de Privacidade',
                feedback: 'Você precisa aceitar antes de continuar',
            },
            buttonText: "Tenho Interesse",
            engagementDisclaimer: {
                title: "Leia com atenção antes de continuar",
                disclaimer: [
                    "O site Montacar serve como uma plataforma para anúncios de peças de carro usadas ou novas.",
                    "É importante entender que o Montacar não atua como intermediário nas transações entre os anunciantes e os interessados.",
                    "Todas as negociações, incluindo preços, condições da peça, envio, forma de pagamento e qualidade do produto, são de responsabilidade exclusiva dos usuários envolvidos.",
                    "",
                    'Ao clicar em "Tenho interesse", você concorda que nós informemos seus dados de contato ao anunciante para que ele entre em contato e vocês negociem a compra/venda da peça. Certifique-se de ler atentamente a descrição do produto, verificar as imagens fornecidas e esclarecer todas as suas dúvidas com o anunciante antes de finalizar qualquer acordo.',
                    "",
                    "O Montacar não se responsabiliza por quaisquer problemas que possam surgir durante ou após a negociação entre os usuários. Recomendamos que você exerça cautela e diligência ao realizar transações online e esteja ciente dos seus direitos e responsabilidades como comprador, incluindo a forma de pagamento.",
                    "",
                    "Se você tiver alguma dúvida ou preocupação, não hesite em entrar em contato conosco para obter suporte adicional através do e-mail: ajuda@montacar.com.br. Obrigado por usar o Montacar e boa sorte com suas negociações!",
                ],
            },
            engagementFails: {
                login: "Faça o login antes de tentar novamente",
                choseOption: "Escolha uma opção"
            },
            engagementListPage: {
                title: "Usuário interessados",
                modal: {
                    continueButton: "Continuar",
                    options: {
                        seeUserDataLabel: "Quero os dados do interessado para negociar",
                        itemSold: {
                            label: "Conversamos e houve a venda da peça",
                            howManyItensText: "Quantas peças foram vendidas"
                        },
                        noAgreement: "Não houve acordo, pode encerrar esse registro"
                    },
                    title: "Como anda essa negociação",
                }
            },
            engagementTable: {
                carPartName: "Peça",
                currentStatus: {
                    CLOSED: "Encerrado",
                    CONTACTED: "Dados do usuário enviados ao seu e-mail",
                    OPENED: "Aguardando seu contato",
                    VIEWED: "Aguardando seu contato",
                    SOLD: "Venda concluída"
                },
                date: "Quando",
                interestedName: "Quem",
                status: "Status"
            },
            informationTitle: "Informações do Produto",
            moreInformations: "+informações do produto",
            shippingDescription: "O frete é combinado diretamente com o anunciante",
            shippingDetails: (advertiserName) => `Este produto é anunciado, fornecido e enviado por ${advertiserName} que garante sua compra do pedido à entrega.`,
            type: {
                new: "Produto Novo",
                used: "Produto Usado",
            },
        },
    }
}